/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShiftUpdate
 */
export interface ShiftUpdate {
    /**
     * 
     * @type {string}
     * @memberof ShiftUpdate
     */
    label?: string | null;
}

/**
 * Check if a given object implements the ShiftUpdate interface.
 */
export function instanceOfShiftUpdate(value: object): value is ShiftUpdate {
    return true;
}

export function ShiftUpdateFromJSON(json: any): ShiftUpdate {
    return ShiftUpdateFromJSONTyped(json, false);
}

export function ShiftUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShiftUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function ShiftUpdateToJSON(json: any): ShiftUpdate {
    return ShiftUpdateToJSONTyped(json, false);
}

export function ShiftUpdateToJSONTyped(value?: ShiftUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
    };
}

